module.exports = __webpack_public_path__ + "static/media/1.ae9ce53d.webp";